"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.get = void 0;
var rogueItems_1 = require("../items/rogueItems");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueCursor_sidecar_1 = require("./rogueCursor-sidecar");
var rogueUiMain_sidecar_1 = require("./rogueUiMain-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
        // isOpen: false,
        };
    }
    return _obj;
};
exports.get = get;
// export const open = () => {
//   let obj = get()
//   obj.isOpen = true
// }
// export const close = () => {
//   let obj = get()
//   obj.isOpen = false
// }
var drawAll = function () {
    var obj = (0, exports.get)();
    if (rogueUiMain_sidecar_1.rogueUiMain.isUiOpen()) {
        return;
    }
    var _a = rogueCursor_sidecar_1.rogueCursor.getGridXY(), gridX = _a.gridX, gridY = _a.gridY;
    var x = 1;
    var y = 1;
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, gridX, gridY);
    if (t) {
        if (t.eVision === rogueMaps_1.EVision.WasSeen) {
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'You cannot see here...');
            y++;
        }
        // if (t.eVision === EVision.None) {
        //   rogueMonofont.write(x, y, 'You cannot see here...')
        //   y++
        // }
        if (t.eVision === rogueMaps_1.EVision.Seen) {
            var monster = rogueMonsters_sidecar_1.rogueMonsters.getAt(gridX, gridY);
            if (monster) {
                if (monster.isPlayer) {
                    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'You');
                }
                else {
                    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, monster.data.char + ' ' + monster.data.name);
                }
                y++;
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, '' + monster.data.description);
                y++;
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'HP: ' + monster.hp);
                y++;
                y++;
            }
            var item = rogueItems_sidecar_1.rogueItems.getAt(gridX, gridY);
            if (item) {
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (0, rogueItems_1.getItemName)(item));
                y++;
                y++;
            }
            if (t.eTile === rogueMaps_1.ETile.Wall) {
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'a wall');
                y++;
            }
            if (t.eTile === rogueMaps_1.ETile.Door) {
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'a door');
                y++;
            }
            if (t.eTile === rogueMaps_1.ETile.DoorOpen) {
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'an open door');
                y++;
            }
            if (t.eTile === rogueMaps_1.ETile.Corridor) {
                rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'a corridor');
                y++;
            }
        }
    }
};
exports.drawAll = drawAll;
